import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {UpperCasePipe} from '@angular/common';

@Component({
    selector: 'app-footer',
    imports: [CommonModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent {

  mailFonte : string = 'info.laurentina@fullmuscle.eu';
  mailTrigoria : string = 'info.trigoria@fullmuscle.eu';
}
